<template>
  <div class="knowledge-page knowledge-client flex-col">
      <div class="knowledge-main-row">
      <div class="knowledge-left-panel flex-col align-stretch" style="flex-shrink:0;width:300px;flex-grow:1;">
        <div class="directory-panel-header">
          <span class="directory-panel-title">目录</span>
          <div class="directory-panel-toolbar">
            <Toolbar :items="directoryTools" v-model="toolBarValue" @on-event="handleDirectoryToolbarEvent" />
            <button
              v-if="selectedDir"
              type="button"
              class="directory-config-btn"
              title="预览"
              @click="handleDirPreview(selectedDir)"
            >
              <BaseIcon icon="md-eye" :size="16" />
            </button>
            <button
              v-if="selectedDir && !isSelectedDirRoot"
              type="button"
              class="directory-config-btn"
              title="目录配置"
              @click="handleDirConfig(selectedDir)"
            >
              <BaseIcon icon="md-settings" :size="16" />
            </button>
          </div>
        </div>
        <KnowledgeDirectory
          :dirs="directories"
          :selected-dir="selectedDir"
          style="flex-grow:1"
          @on-select="handleDirSelect"
          @on-drop-in="handleDirDropIn"
          @on-drop-file="handleFileDropToDir"
          @on-config="handleDirConfig"
          @on-context-action="handleDirContextAction"
        ></KnowledgeDirectory>
      </div>
       
        <div class="flex-col align-stretch" style="flex-grow:1;width:calc(100% - 300px);">
          <div class="data-panel-header">
            <Input
              v-model="searchText"
              search
              placeholder="搜索内容"
              clearable
              class="data-search-input"
            />
            <Toolbar :items="dataTools" v-model="toolBarValue" @on-event="handleDataToolbarEvent" @input="handleToolbarInput" class="data-panel-toolbar"/>
          </div>
          <KnowledgeList
          style="flex-grow:1"
          :loading="loading"
          :items="filteredItems"
          :subdirs="selectedSubdirs"
          :all-items="allItems"
          :view-mode="viewMode"
          :dir-editable="selectedDirEditable"
          @on-drop-in-folder="handleItemDropInFolder"
          @on-drop-in-dir="handleFileDropToDir"
          @on-select="handleItemSelect"
          @on-open="handleItemOpen"
          @on-edit="handleItemEdit"
          @on-file-drop="handleFileDrop"
          @on-dir-select="handleDirSelect"
          @on-context-menu="handleItemContextMenu"
          @on-markdown="handleItemMarkdown"
        ></KnowledgeList>
        </div>

      </div>
        <div class="knowledge-status-bar">
          <span class="status-path">
            <template v-if="!selectedDir">未选中</template>
            <template v-else>
              <span
                v-for="(dir, idx) in selectedDirPathArray"
                :key="dir.id"
                class="status-path-item"
              >
                <span v-if="idx > 0" class="status-path-sep"><BaseIcon icon="ios-arrow-forward" :size="12" /></span>
                <span class="status-path-link" @click="handleDirSelect(dir)">{{ dir.name }}</span>
              </span>
            </template>
          </span>
          <span class="status-meta">
            <span class="status-count">{{ selectedDir ? filteredItems.length : 0 }} 个文件</span>
            <span class="status-usage">128 MB / 1 GB</span>
            <span v-if="selectedDirChargerId" class="status-charger">
              <span class="status-charger-label">目录管理员</span>
              <BaseNameBoard :uid="selectedDirChargerId" :size="18" />
            </span>
          </span>
        </div>

        <Drawer v-model="showDetail" :width="800" :styles="{
          padding:0
        }">
          <KnowledgeDetail :current="current" :all-items="allItems" />
        </Drawer>

        <!-- 目录编辑对话框 -->
        <Modal v-model="showDirEditor" :title="dirEditorTitle" footer-hide :mask-closable="false">
          <div class="knowledge-modal-content">
            <Form :model="dirForm" :label-width="100">
              <FormItem label="目录类型">
                <RadioGroup v-model="dirForm.type" class="dir-type-selector">
                  <Radio label="dir" class="dir-type-option">
                    <BaseIcon icon="md-folder" :size="20" style="margin-right:5px;" />
                    <span>目录</span>
                  </Radio>
                  <Radio label="link-dir" class="dir-type-option">
                    <BaseIcon icon="lianjie" :size="20" style="margin-right:5px;" />
                    <span>引用目录</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="目录名称">
                <Input v-model="dirForm.name" placeholder="请输入目录名称" size="large" :maxlength="50" />
              </FormItem>
              <FormItem label="描述">
                <Input 
                  v-model="dirForm.description" 
                  type="textarea" 
                  :rows="3" 
                  placeholder="请输入目录描述（最多128字）" 
                  size="large"
                  :maxlength="128"
                  show-word-limit
                />
              </FormItem>
              <FormItem label="远程API" v-if="dirForm.type === 'link-dir'">
                <Input v-model="dirForm.remote_api" placeholder="请输入远程API地址" size="large" />
              </FormItem>
            </Form>
          </div>
          <div class="knowledge-modal-footer">
            <Button @click="handleDirCancel" size="large">取消</Button>
            <Button type="primary" @click="handleDirSubmit" size="large" style="margin-left:10px;">确定</Button>
          </div>
        </Modal>

        <!-- 目录配置对话框 -->
        <Modal
          v-model="showDirPermission"
          footer-hide
          :mask-closable="false"
          width="760"
          class-name="knowledge-dir-config-modal"
        >
          <div slot="header" class="dir-config-header" v-if="permissionDir">
            <div class="dir-config-header-icon">
              <BaseIcon icon="md-folder" :size="22" />
            </div>
            <div class="dir-config-header-main">
              <div class="dir-config-title">目录配置</div>
              <div class="dir-config-subtitle">{{ permissionDir.name }}</div>
            </div>
          </div>

          <div class="dir-config-body" v-if="permissionDir">
            <div class="dir-config-section">
              <div class="dir-config-section-title">基础设置</div>
              <div class="dir-config-card">
                <div class="dir-config-field">
                  <label class="dir-config-label">目录管理员</label>
                  <BaseUserSelectGrouped
                    v-model="permissionForm.charger_id"
                    placeholder="选择目录管理员"
                  />
                </div>
                <div class="dir-config-field">
                  <label class="dir-config-label">目录说明</label>
                  <Input
                    v-model="permissionForm.description"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入目录说明，便于成员了解用途"
                    :maxlength="128"
                    show-word-limit
                  />
                </div>
                <div class="dir-config-switch-grid">
                  <div class="dir-config-switch-item">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">允许编辑内容</span>
                      <span class="dir-config-switch-desc">关闭后目录内文件只读，不可上传/移动/删除</span>
                    </div>
                    <Switch v-model="permissionForm.editable" />
                  </div>
                  <div class="dir-config-switch-item">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">启用审批</span>
                      <span class="dir-config-switch-desc">上传或变更内容时需经过审批流程</span>
                    </div>
                    <Switch v-model="permissionForm.enable_approval" />
                  </div>
                  <div class="dir-config-switch-item">
                    <div class="dir-config-switch-meta">
                      <span class="dir-config-switch-name">允许创建子目录</span>
                      <span class="dir-config-switch-desc">关闭后该目录下不可新建子目录</span>
                    </div>
                    <Switch v-model="permissionForm.enable_create_sub" />
                  </div>
                </div>
              </div>
            </div>

            <div class="dir-config-section">
              <div class="dir-config-section-head">
                <div>
                  <div class="dir-config-section-title">授权面板</div>
                  <div class="dir-config-section-desc">按部门 / 人员 / 项目 / 所有人配置可见、可上传、可编辑权限</div>
                </div>
                <Button type="primary" ghost size="small" icon="md-add" @click="handleAddPermissionRow">添加授权</Button>
              </div>

              <div class="dir-config-perm-add" v-if="showPermAddForm">
                <div class="dir-config-perm-add-row">
                  <Select v-model="permAddForm.target_type" style="width:110px;" transfer @on-change="handlePermTargetTypeChange">
                    <Option value="dep">部门</Option>
                    <Option value="user">人员</Option>
                    <Option value="project">项目</Option>
                    <Option value="all">所有人</Option>
                  </Select>
                  <span v-if="permAddForm.target_type === 'all'" class="dir-config-perm-all-tip">对所有人生效</span>
                  <Select
                    v-else-if="permAddForm.target_type === 'dep'"
                    v-model="permAddForm.target_id"
                    filterable
                    clearable
                    placeholder="选择部门"
                    style="flex:1;min-width:160px;"
                    transfer
                  >
                    <Option v-for="dep in sessionDeps" :key="'dep-'+dep.id" :value="String(dep.id)">{{ dep.name }}</Option>
                  </Select>
                  <BaseUserSelectGrouped
                    v-else-if="permAddForm.target_type === 'user'"
                    v-model="permAddForm.target_id"
                    placeholder="选择人员"
                    style="flex:1;min-width:160px;"
                  />
                  <Select
                    v-else
                    v-model="permAddForm.target_id"
                    filterable
                    clearable
                    placeholder="选择项目"
                    style="flex:1;min-width:160px;"
                    transfer
                  >
                    <Option v-for="proj in sessionProjects" :key="'proj-'+proj.id" :value="String(proj.id)">{{ proj.name }}</Option>
                  </Select>
                </div>
                <div class="dir-config-perm-add-row dir-config-perm-flags">
                  <RadioGroup v-model="permAddForm.effect" type="button" size="small">
                    <Radio label="allow">允许</Radio>
                    <Radio label="deny">禁止</Radio>
                  </RadioGroup>
                  <Checkbox v-model="permAddForm.visible">可见</Checkbox>
                  <Checkbox v-model="permAddForm.upload">可上传</Checkbox>
                  <Checkbox v-model="permAddForm.edit">可编辑</Checkbox>
                  <div class="dir-config-perm-add-actions">
                    <Button size="small" @click="cancelPermAddForm">取消</Button>
                    <Button type="primary" size="small" @click="confirmPermAddForm">确认</Button>
                  </div>
                </div>
              </div>

              <div class="dir-config-perm-table-wrap">
                <table class="dir-config-perm-table" v-if="permissionForm.permissions.length">
                  <thead>
                    <tr>
                      <th>类型</th>
                      <th>授权对象</th>
                      <th class="perm-effect-col">策略</th>
                      <th class="perm-flag-col">可见</th>
                      <th class="perm-flag-col">可上传</th>
                      <th class="perm-flag-col">可编辑</th>
                      <th class="perm-action-col">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in permissionForm.permissions" :key="rowKey(row, index)">
                      <td>
                        <Tag :color="permissionTypeColor(row.target_type)">{{ permissionTypeLabel(row.target_type) }}</Tag>
                      </td>
                      <td>{{ resolvePermissionTargetName(row) }}</td>
                      <td class="perm-effect-col">
                        <Select v-model="row.effect" transfer size="small" style="width:88px;">
                          <Option value="allow">允许</Option>
                          <Option value="deny">禁止</Option>
                        </Select>
                      </td>
                      <td class="perm-flag-col"><Checkbox v-model="row.visible" /></td>
                      <td class="perm-flag-col"><Checkbox v-model="row.upload" /></td>
                      <td class="perm-flag-col"><Checkbox v-model="row.edit" /></td>
                      <td class="perm-action-col">
                        <Button type="text" size="small" class="perm-remove-btn" @click="removePermissionRow(index)">删除</Button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="dir-config-perm-empty">暂无授权，点击「添加授权」配置部门 / 人员 / 项目 / 所有人权限</div>
              </div>
            </div>
          </div>

          <div class="knowledge-modal-footer dir-config-footer">
            <Button @click="showDirPermission = false" size="large">取消</Button>
            <Button type="primary" @click="handlePermissionSubmit" size="large" style="margin-left:10px;">保存配置</Button>
          </div>
        </Modal>

        <!-- 内容编辑对话框 -->
        <Modal
          v-model="showItemEditor"
          :width="980"
          footer-hide
          :mask-closable="false"
          class-name="knowledge-item-editor-modal"
        >
          <div slot="header" class="item-editor-header">
            <div class="item-editor-header-left">
              <span class="item-editor-mode">{{ itemForm.id ? '编辑内容' : '新建内容' }}</span>
              <span class="item-editor-subtitle">{{ currentTypeLabel }}</span>
            </div>
            <div class="item-editor-nav">
              <button
                type="button"
                class="item-editor-nav-btn"
                :class="{ active: editorTab === 'basic' }"
                @click="editorTab = 'basic'"
              >基本信息</button>
              <button
                type="button"
                class="item-editor-nav-btn"
                :class="{ active: editorTab === 'markdown' }"
                @click="editorTab = 'markdown'"
              >Markdown 解析</button>
            </div>
          </div>

          <div v-show="editorTab === 'basic'" class="item-editor-body">
            <div class="item-editor-layout">
              <aside class="item-editor-sidebar">
                <div class="sidebar-section">
                  <div class="sidebar-label">内容类型</div>
                  <div class="type-selector type-selector-vertical">
                    <div
                      v-for="typeOption in typeOptions"
                      :key="typeOption.value"
                      class="type-option"
                      :class="{ active: itemForm.type === typeOption.value }"
                      @click="itemForm.type = typeOption.value; handleItemTypeChange()"
                    >
                      <BaseIcon :icon="typeOption.icon" :size="22" />
                      <span>{{ typeOption.label }}</span>
                    </div>
                  </div>
                </div>
                <div class="sidebar-section">
                  <div class="sidebar-label">所属目录</div>
                  <Select v-model="itemForm.dir_id" clearable size="large" transfer>
                    <Option value="">无</Option>
                    <Option v-for="dir in allDirectories" :key="dir.id" :value="dir.id">{{ dir.name }}</Option>
                  </Select>
                </div>
              </aside>

              <main class="item-editor-main">
                <div class="editor-field">
                  <label class="editor-field-label">标题</label>
                  <Input
                    v-model="itemForm.name"
                    placeholder="请输入标题"
                    size="large"
                    :maxlength="100"
                    class="editor-title-input"
                  />
                </div>

                <div class="editor-field" v-if="itemForm.type === 'file'">
                  <label class="editor-field-label">文件上传</label>
                  <div class="editor-upload-card">
                    <Upload :before-upload="handleFileUpload" action="">
                      <Button icon="ios-cloud-upload-outline" type="primary" ghost size="large">选择文件</Button>
                    </Upload>
                    <div v-if="itemForm.content" class="editor-file-preview">
                      <BaseIcon icon="wenjian" :size="18" />
                      <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
                    </div>
                    <div v-else class="editor-file-empty">尚未上传文件</div>
                  </div>
                </div>

                <div class="editor-field" v-if="itemForm.type === 'text'">
                  <label class="editor-field-label">文本内容</label>
                  <Input
                    v-model="itemForm.content"
                    type="textarea"
                    :rows="14"
                    placeholder="请输入文本内容"
                    class="editor-textarea"
                  />
                </div>

                <div class="editor-field" v-if="itemForm.type === 'md'">
                  <label class="editor-field-label">Markdown 内容</label>
                  <div class="markdown-editor-wrapper editor-content-panel">
                    <MarkdownEditor v-model="itemForm.content" />
                  </div>
                </div>

                <div class="editor-field" v-if="itemForm.type === 'html'">
                  <label class="editor-field-label">HTML 内容</label>
                  <div class="html-editor-wrapper editor-content-panel">
                    <TextEditor v-model="itemForm.content" />
                  </div>
                </div>
              </main>
            </div>
          </div>

          <div v-show="editorTab === 'markdown'" class="item-editor-body item-editor-body-markdown">
            <Alert show-icon type="info" class="markdown-parse-tip">
              将原始文件解析为 Markdown，用于摘要检索与原文链接；非 Markdown 格式文件可在此维护解析结果。
            </Alert>
            <div class="markdown-parse-meta">
              <span class="markdown-parse-label">解析状态</span>
              <Tag :color="itemForm.has_markdown ? 'success' : 'default'">
                {{ itemForm.has_markdown ? '已生成 Markdown' : '未解析' }}
              </Tag>
              <Button
                v-if="showMarkdownParseBtn"
                type="primary"
                ghost
                size="small"
                :loading="markdownParsing"
                @click="handleParseMarkdown"
              >触发解析</Button>
            </div>
            <div class="editor-field">
              <label class="editor-field-label">摘要内容</label>
              <div class="markdown-editor-wrapper editor-content-panel">
                <MarkdownEditor v-model="itemForm.markdown_content" />
              </div>
            </div>
            <div v-if="itemForm.content && itemForm.type === 'file'" class="editor-source-link">
              <span class="markdown-parse-label">原文链接</span>
              <a :href="itemForm.content" target="_blank">{{ itemForm.content }}</a>
            </div>
          </div>

          <div class="knowledge-modal-footer item-editor-footer">
            <Button @click="handleItemCancel" size="large">取消</Button>
            <Button type="primary" @click="handleItemSubmit" size="large" style="margin-left:10px;">保存</Button>
          </div>
        </Modal>
  </div>
</template>

<script>
import KnowledgeDirectory from '@/components/knowledge/directory'
import KnowledgeList from '@/components/knowledge/list'
import KnowledgeDetail from '@/components/knowledge/detail'
import Toolbar from '@/components/app/toolbar'
import MarkdownEditor from '@/components/base/MarkdownEditor'
import TextEditor from '@/components/base/TextEditor'
import BaseIcon from '@/components/base/Icon'
import UTIL from '@/utils'
import { mapGetters } from 'vuex'

const EMPTY_PERMISSION_FORM = () => ({
  editable: true,
  enable_approval: false,
  enable_create_sub: true,
  description: '',
  charger_id: '',
  permissions: [],
})

const EMPTY_PERM_ADD_FORM = () => ({
  target_type: 'dep',
  target_id: '',
  effect: 'allow',
  visible: true,
  upload: false,
  edit: false,
})

export default {
    routerOption: {},
    data(){
      return {
        directories:[],
        items:[],
        allItems:[],
        loading:false,
        showDetail:false,
        current:null,
        selectedDir:null,
        selectedItems:[],
        searchText:'',
        toolBarValue:{
          view_mode:'icon'
        },
        editorTab: 'basic',
        markdownParsing: false,
        showDirEditor:false,
        dirForm:{
          name:'',
          type:'dir',
          remote_api:'',
          description:''
        },
        showItemEditor:false,
        itemForm:{
          type:'text',
          content:'',
          dir_id:'',
          markdown_content:'',
          has_markdown: false,
        },
        showDirPermission:false,
        permissionDir:null,
        permissionForm: EMPTY_PERMISSION_FORM(),
        showPermAddForm: false,
        permAddForm: EMPTY_PERM_ADD_FORM(),
      }
    },
    components:{KnowledgeDirectory,KnowledgeList,Toolbar,KnowledgeDetail,MarkdownEditor,TextEditor,BaseIcon},
    computed:{
      ...mapGetters('session', ['deps', 'projects', 'users']),
      sessionDeps() {
        return this.deps || []
      },
      sessionProjects() {
        return this.projects || []
      },
      viewMode(){
        if(this.toolBarValue){
          return this.toolBarValue.view_mode
        }
        return 'icon'
      },
      filteredItems(){
        let items = this.allItems
        if(this.selectedDir){
          const dirIds = this.getDirIdWithDescendants(this.selectedDir.id)
          items = items.filter(item => item.dir_id && dirIds.includes(item.dir_id))
        }
        if(this.searchText){
          const search = this.searchText.toLowerCase()
          items = items.filter(item => {
            const name = (item.name || '').toLowerCase()
            const content = (item.content || '').toLowerCase()
            return name.includes(search) || content.includes(search)
          })
        }
        return items
      },
      selectedDirPath(){
        if(!this.selectedDir) return ''
        return this.selectedDirPathArray.map(d => d.name).join(' / ')
      },
      selectedDirPathArray(){
        if(!this.selectedDir) return []
        const path = []
        let cur = this.selectedDir
        while(cur){
          path.unshift(cur)
          if(!cur.parent_id) break
          cur = this.allDirectories.find(d => d.id === cur.parent_id) || null
        }
        return path
      },
      selectedSubdirs(){
        if(!this.selectedDir) return []
        return (this.selectedDir.subs || []).slice()
      },
      selectedDirEditable(){
        if(!this.selectedDir) return true
        return this.selectedDir.editable !== false
      },
      selectedDirChargerId() {
        if (!this.selectedDir) return null
        const dir = this.findDirectoryById(this.selectedDir.id) || this.selectedDir
        return dir.charger_id || null
      },
      isSelectedDirRoot(){
        if(!this.selectedDir) return false
        return this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined
      },
      allDirectories(){
        return UTIL.plat(this.directories, {LIST_KEY: 'subs'}) || []
      },
      availableDirectories(){
        return this.allDirectories.filter(dir => dir.id !== this.dirForm.id)
      },
      typeOptions(){
        return [
          { value: 'file', label: '文件', icon: 'wenjian' },
          { value: 'text', label: '文本', icon: 'md-document' },
          { value: 'md', label: 'Markdown', icon: 'codelibrary-fill' },
          { value: 'html', label: 'HTML', icon: 'css' },
        ]
      },
      directoryTools(){
        const hasSelected = !!this.selectedDir
        const isRoot = hasSelected && (this.selectedDir.parent_id === null || this.selectedDir.parent_id === undefined)
        const notEditable = hasSelected && this.selectedDir.editable === false
        const notCreateSub = hasSelected && this.selectedDir.enable_create_sub === false
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled:!hasSelected || isRoot
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled:!hasSelected || isRoot
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
          disabled: !hasSelected || notEditable || notCreateSub
        },
        ...editBtns,
        ]
      },
      dataTools(){
        const hasSelected = this.selectedItems.length > 0
        const canEdit = this.selectedItems.length === 1
        const canMirror = this.selectedItems.length > 0 && this.selectedItems.every(item => item.type !== 'ref')
        const dirEditable = this.selectedDir && this.selectedDir.editable !== false
        const editBtns = [{
          type:"icon-button",
          icon:'md-create',
          name:'编辑',
          key:'edit',
          disabled: !hasSelected || !canEdit
        },{
          type:"icon-button",
          icon:'md-copy',
          name:'镜像',
          key:'mirror',
          disabled: !hasSelected || !canMirror
        },{
          type:"icon-button",
          icon:'md-trash',
          name:'删除',
          key:'remove',
          disabled: !hasSelected
        }]

        return [{
          type:"icon-button",
          icon:'md-add',
          name:'新增',
          key:'add',
          disabled: !this.selectedDir || !dirEditable
        },
        ...editBtns,
        {
          type:'divider',
        },
        {
          type:'tabs',
          key:'view_mode',
          subs:[{
          type:"icon-button",
          icon:'md-speedometer',
          name:'图标',
          togglable:true,
          key:'icon',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'列表',
          togglable:true,
          key:'list',
        },{
          type:"icon-button",
          icon:'pm2',
          name:'大纲',
          togglable:true,
          key:'brief',
        }]
        }]
      },
      dirEditorTitle(){
        return this.dirForm.id ? '编辑目录' : '新建目录'
      },
      itemEditorTitle(){
        return this.itemForm.id ? '编辑内容' : '新建内容'
      },
      showMarkdownParseBtn() {
        return this.itemForm.type === 'file';
      },
      currentTypeLabel() {
        const found = this.typeOptions.find(item => item.value === this.itemForm.type);
        return found ? found.label : '内容';
      },
    },
    mounted(){
      this.loading = true
      this.$api.afterLogin(()=>{
        this.fetchDirectories()
        this.fetchItems()
      })
    },
    methods:{
      sameId(a, b) {
        if (a == null || b == null || a === '' || b === '') return false;
        return String(a) === String(b);
      },
      findDirectoryById(id) {
        return this.allDirectories.find(dir => this.sameId(dir.id, id));
      },
      findItemById(id) {
        return this.allItems.find(item => this.sameId(item.id, id));
      },
      isDirectoryId(id) {
        return this.allDirectories.some(dir => this.sameId(dir.id, id));
      },
      refreshItemsAfterMove(draggedId, targetDirId) {
        const stillVisible = this.selectedDir
          && this.getDirIdWithDescendants(this.selectedDir.id).some(dirId => this.sameId(dirId, targetDirId));
        if (stillVisible) {
          this.fetchItems();
          return;
        }
        this.allItems = this.allItems.map(item => (
          this.sameId(item.id, draggedId) ? {...item, dir_id: targetDirId} : item
        ));
        this.items = this.items.filter(item => !this.sameId(item.id, draggedId));
      },
      fetchDirectories(){
        this.loading = true
        this.$api.get('/knowledge/directories').then(res=>{
          this.directories = res.data.data || []
          if (this.selectedDir) {
            const updated = this.allDirectories.find(dir => this.sameId(dir.id, this.selectedDir.id))
            if (updated) this.selectedDir = updated
          }
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取目录列表失败: ' + err)
          this.loading = false
        })
      },
      fetchItems(){
        this.loading = true
        this.$api.get('/knowledge/data').then(res=>{
          this.allItems = res.data.data || []
          this.items = this.allItems
          this.loading = false
        }).catch(err=>{
          this.$Message.error('获取内容列表失败: ' + err)
          this.loading = false
        })
      },
      getDirIdWithDescendants(dirId){
        const ids = [dirId]
        const children = (this.allDirectories || []).filter(d => d.parent_id === dirId)
        children.forEach(c => {
          ids.push(...this.getDirIdWithDescendants(c.id))
        })
        return ids
      },
      handleDirSelect(dir){
        this.selectedDir = dir
        this.selectedItems = []
      },
      handleDirPreview(dir) {
        if (!dir || dir.id == null) return
        this.RouteTo(`/core/documents/${dir.id}/view`, true)
      },
      handleDirConfig(dir){
        if (!dir) return
        this.permissionDir = dir
        this.permissionForm = this.buildPermissionForm(dir)
        this.resetPermAddForm()
        this.$store.dispatch('session/getDeps')
        this.$store.dispatch('session/getProjects')
        this.$store.dispatch('session/getUsers')
        this.showDirPermission = true
      },
      buildPermissionForm(dir) {
        const permissions = Array.isArray(dir.permissions)
          ? dir.permissions.map(item => ({
            target_type: item.target_type || 'dep',
            target_id: item.target_type === 'all'
              ? (item.target_id || 'all')
              : (item.target_id != null ? String(item.target_id) : ''),
            effect: item.effect === 'deny' ? 'deny' : 'allow',
            visible: item.visible !== false,
            upload: !!item.upload,
            edit: !!item.edit,
          })).filter(item => item.target_type === 'all' ? true : !!item.target_id)
          : []
        return {
          editable: dir.editable !== false,
          enable_approval: !!dir.enable_approval,
          enable_create_sub: dir.enable_create_sub !== false,
          description: dir.description || '',
          charger_id: dir.charger_id || '',
          permissions,
        }
      },
      handlePermTargetTypeChange() {
        this.permAddForm.target_id = this.permAddForm.target_type === 'all' ? 'all' : ''
      },
      resetPermAddForm() {
        this.showPermAddForm = false
        this.permAddForm = EMPTY_PERM_ADD_FORM()
      },
      handleAddPermissionRow() {
        this.showPermAddForm = true
        this.permAddForm = EMPTY_PERM_ADD_FORM()
      },
      cancelPermAddForm() {
        this.resetPermAddForm()
      },
      confirmPermAddForm() {
        const { target_type, target_id, effect, visible, upload, edit } = this.permAddForm
        const normalizedId = target_type === 'all' ? 'all' : (target_id ? String(target_id) : '')
        if (!normalizedId) {
          this.$Message.warning('请选择授权对象')
          return
        }
        const duplicated = (this.permissionForm.permissions || []).some(item =>
          item.target_type === target_type && String(item.target_id) === normalizedId
        )
        if (duplicated) {
          this.$Message.warning('该授权对象已存在')
          return
        }
        this.permissionForm.permissions.push({
          target_type,
          target_id: normalizedId,
          effect: effect === 'deny' ? 'deny' : 'allow',
          visible: visible !== false,
          upload: !!upload,
          edit: !!edit,
        })
        this.resetPermAddForm()
      },
      removePermissionRow(index) {
        this.permissionForm.permissions.splice(index, 1)
      },
      permissionTypeLabel(type) {
        const map = { dep: '部门', user: '人员', project: '项目', all: '所有人' }
        return map[type] || type || '-'
      },
      permissionTypeColor(type) {
        const map = { dep: 'blue', user: 'green', project: 'gold', all: 'purple' }
        return map[type] || 'default'
      },
      resolvePermissionTargetName(row) {
        if (!row) return '-'
        if (row.target_type === 'all') return '所有人'
        if (!row.target_id) return '-'
        const id = String(row.target_id)
        if (row.target_type === 'dep') {
          const dep = (this.sessionDeps || []).find(item => String(item.id) === id)
          return dep ? dep.name : id
        }
        if (row.target_type === 'project') {
          const proj = (this.sessionProjects || []).find(item => String(item.id) === id)
          return proj ? proj.name : id
        }
        if (row.target_type === 'user') {
          const user = (this.users || []).find(item => String(item.id) === id)
          return user ? user.name : id
        }
        return id
      },
      rowKey(row, index) {
        return `${row.target_type || 'dep'}-${row.target_id || index}-${index}`
      },
      handlePermissionSubmit(){
        if(!this.permissionDir) return
        const payload = {
          editable: this.permissionForm.editable,
          enable_approval: !!this.permissionForm.enable_approval,
          enable_create_sub: this.permissionForm.enable_create_sub !== false,
          description: this.permissionForm.description || '',
          charger_id: this.permissionForm.charger_id || null,
          permissions: (this.permissionForm.permissions || []).map(item => ({
            target_type: item.target_type,
            target_id: item.target_type === 'all' ? 'all' : item.target_id,
            effect: item.effect === 'deny' ? 'deny' : 'allow',
            visible: item.visible !== false,
            upload: !!item.upload,
            edit: !!item.edit,
          })),
        }
        this.$api.patch(`/knowledge/directories/${this.permissionDir.id}`, payload).then(() => {
          this.$Message.success('保存成功')
          this.showDirPermission = false
          this.resetPermAddForm()
          this.fetchDirectories()
        }).catch(err => {
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleDirContextAction({ action, dir }){
        if(!dir) return
        if(action === 'add'){
          if (dir.enable_create_sub === false) {
            this.$Message.warning('该目录不允许创建子目录')
            return
          }
          this.selectedDir = dir
          this.dirForm = { name: '', type: 'dir', parent_id: dir.id, remote_api: '', description: '' }
          this.showDirEditor = true
        } else if(action === 'edit'){
          this.selectedDir = dir
          this.dirForm = { id: dir.id, name: dir.name, type: dir.type, parent_id: dir.parent_id, remote_api: dir.remote_api || '', description: dir.description || '' }
          this.showDirEditor = true
        } else if(action === 'remove'){
          this.$Modal.confirm({
            title: '确认删除',
            content: `确定要删除目录"${dir.name}"吗？`,
            onOk: () => {
              this.$api.delete(`/knowledge/directories/${dir.id}`).then(() => {
                this.$Message.success('删除成功')
                if(this.selectedDir && this.selectedDir.id === dir.id) this.selectedDir = null
                this.fetchDirectories()
              }).catch(err => this.$Message.error('删除失败: ' + err))
            }
          })
        }
      },
      handleItemContextMenu(payload){
        const { action, item } = payload
        if(action === 'edit' && item){
          this.handleItemEdit(item)
        } else if(action === 'remove' && item){
          this.selectedItems = [item]
          this.handleDataToolbarEvent({ key: 'remove' })
        } else if(action === 'open' && item){
          this.handleItemOpen(item)
        }
      },
      handleItemSelect(items){
        this.selectedItems = items
      },
      handleDirDropIn(data){
        const {draggedId, targetDirId} = data || {}
        if (!draggedId || !targetDirId || this.sameId(draggedId, targetDirId)) return
        if (!this.isDirectoryId(draggedId)) return

        const targetDir = this.findDirectoryById(targetDirId)
        if(targetDir && targetDir.editable === false){
          this.$Message.warning('该目录为只读，无法放入')
          return
        }
        this.$api.put(`/knowledge/directories/${draggedId}`, {
          parent_id: targetDirId
        }).then(()=>{
          this.$Message.success('移动成功')
          this.fetchDirectories()
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleFileDropToDir(data){
        const {draggedId, targetDirId} = data || {}
        if (!draggedId || !targetDirId) return
        if (this.isDirectoryId(draggedId)) return

        const targetDir = this.findDirectoryById(targetDirId)
        if(targetDir && targetDir.editable === false){
          this.$Message.warning('该目录为只读，无法移动文件')
          return
        }
        const draggedItem = this.findItemById(draggedId)
        if(!draggedItem){
          this.$Message.warning('未找到要移动的内容')
          return
        }
        if (this.sameId(draggedItem.dir_id, targetDirId)) return

        this.$api.put(`/knowledge/data/${draggedId}`, {
          dir_id: targetDirId
        }).then(()=>{
          this.$Message.success('移动成功')
          this.refreshItemsAfterMove(draggedId, targetDirId)
        }).catch(err=>{
          this.$Message.error('移动失败: ' + err)
        })
      },
      handleItemDropInFolder(data){
        const {draggedId, targetItemId} = data || {}
        const targetItem = this.findItemById(targetItemId)
        if(!targetItem || targetItem.dir_id == null){
          this.$Message.warning('无法移动到该位置')
          return
        }
        if (this.sameId(draggedId, targetItemId)) return
        this.handleFileDropToDir({
          draggedId,
          targetDirId: targetItem.dir_id,
        })
      },
      handleFileDrop(files){
        if(!files || files.length === 0) return
        if(!this.selectedDir){
          this.$Message.warning('请先选择目录')
          return
        }
        if(this.selectedDir.editable === false){
          this.$Message.warning('当前目录为只读，无法上传')
          return
        }
        const dirId = this.selectedDir.id
        const coskey = this.$store.getters['session/session'] && this.$store.getters['session/session'].coskey
        if(!coskey){
          this.$Message.warning('未配置上传，请使用「新增」选择文件上传')
          return
        }
        this.$cos.upload(files, {
          onSuccess: (uploaded) => {
            if(uploaded && uploaded.length > 0){
              const promises = uploaded.map(f => {
                const name = (f.name || '').replace(/\.[^/.]+$/, '') || '未命名'
                return this.$api.post('/knowledge/data', {
                  type: 'file',
                  content: f.url,
                  dir_id: dirId,
                  name: name || undefined
                })
              })
              Promise.all(promises).then(() => {
                this.$Message.success(`成功上传 ${uploaded.length} 个文件`)
                this.fetchItems()
              }).catch(err => this.$Message.error('创建记录失败: ' + err))
            }
          },
          onFail: (err) => this.$Message.error('上传失败: ' + err)
        }, { coskey })
      },
      handleDirectoryToolbarEvent(e){
        const {key} = e
        if(key === 'add'){
          if (this.selectedDir && this.selectedDir.enable_create_sub === false) {
            this.$Message.warning('该目录不允许创建子目录')
            return
          }
          this.dirForm = {
            name:'',
            type:'dir',
            parent_id:this.selectedDir ? this.selectedDir.id : null,
            remote_api:'',
            description:''
          }
          this.showDirEditor = true
        }else if(key === 'edit'){
          if(!this.selectedDir) return
          // 系统目录不可编辑
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可编辑')
            return
          }
          this.dirForm = {
            id:this.selectedDir.id,
            name:this.selectedDir.name,
            type:this.selectedDir.type,
            parent_id:this.selectedDir.parent_id,
            remote_api:this.selectedDir.remote_api || '',
            description:this.selectedDir.description || ''
          }
          this.showDirEditor = true
        }else if(key === 'remove'){
          if(!this.selectedDir) return
          // 系统目录不可删除
          if(this.selectedDir.type === 'system'){
            this.$Message.warning('系统目录不可删除')
            return
          }
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除目录"${this.selectedDir.name}"吗？`,
            onOk:()=>{
              this.$api.delete(`/knowledge/directories/${this.selectedDir.id}`).then(()=>{
                this.$Message.success('删除成功')
                this.selectedDir = null
                this.fetchDirectories()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }
      },
      handleDataToolbarEvent(e){
        const {key,type,value} = e
        if(key === 'add'){
          this.editorTab = 'basic';
          this.itemForm = {
            type:'text',
            content:'',
            dir_id: this.selectedDir ? this.selectedDir.id : '',
            name:'',
            markdown_content:'',
            has_markdown: false,
          };
          this.showItemEditor = true
        }else if(key === 'edit'){
          if(this.selectedItems.length !== 1) return
          const item = this.selectedItems[0]
          this.fillItemForm(item)
          this.showItemEditor = true
        }else if(key === 'remove'){
          if(this.selectedItems.length === 0) return
          this.$Modal.confirm({
            title:'确认删除',
            content:`确定要删除选中的${this.selectedItems.length}个项目吗？`,
            onOk:()=>{
              const promises = this.selectedItems.map(item => 
                this.$api.delete(`/knowledge/data/${item.id}`)
              )
              Promise.all(promises).then(()=>{
                this.$Message.success('删除成功')
                this.selectedItems = []
                this.fetchItems()
              }).catch(err=>{
                this.$Message.error('删除失败: ' + err)
              })
            }
          })
        }else if(type == 'tab-change'){
          this.toolBarValue.toolBarValue.view_mode = value
        }else if(key === 'mirror'){
          if(this.selectedItems.length === 0) return
          // 检查是否都是引用类型，引用类型不能镜像
          if(this.selectedItems.some(item => item.ref)){
            this.$Message.warning('引用类型不能创建镜像')
            return
          }
          // 直接在当前选中的目录创建镜像，如果没有选中目录则使用原文件的目录
          const targetDirId = this.selectedDir ? this.selectedDir.id : (this.selectedItems[0] ? this.selectedItems[0].dir_id : null)
          
          if(!targetDirId){
            this.$Message.warning('请先选择目录')
            return
          }
          
          // 为每个选中的项目创建引用数据，保持原类型和名称，设置ref为true
          const promises = this.selectedItems.map(item => {
            // 获取源文件（如果是引用文件，需要找到真正的源文件）
            const sourceItem = item.ref && item.content ? this.allItems.find(i => i.id === item.content) : item
            return this.$api.post('/knowledge/data', {
              type: sourceItem.type, // 保持原类型
              content: sourceItem.id, // 引用原始内容的ID
              dir_id: targetDirId,
              ref: true // 标记为引用
            })
          })
          
          Promise.all(promises).then(()=>{
            this.$Message.success(`成功创建 ${this.selectedItems.length} 个镜像`)
            this.fetchItems()
          }).catch(err=>{
            this.$Message.error('创建镜像失败: ' + err)
          })
        }
      },
      handleDirSubmit(){
        if(!this.dirForm.name){
          this.$Message.warning('请输入目录名称')
          return
        }
        const url = this.dirForm.id 
          ? `/knowledge/directories/${this.dirForm.id}`
          : '/knowledge/directories'
        const method = this.dirForm.id ? 'put' : 'post'
        
        this.$api[method](url, this.dirForm).then(()=>{
          this.$Message.success('保存成功')
          this.showDirEditor = false
          this.fetchDirectories()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleDirCancel(){
        this.showDirEditor = false
        this.dirForm = {
          name:'',
          type:'dir',
          parent_id:null,
          remote_api:'',
          description:''
        }
      },
      handleItemSubmit(){
        if(!this.itemForm.type){
          this.$Message.warning('请选择类型')
          return
        }
        if(this.itemForm.type === 'file' && !this.itemForm.content){
          this.$Message.warning('请上传文件')
          return
        }
        if(this.itemForm.type !== 'file' && !this.itemForm.content){
          this.$Message.warning('请输入内容')
          return
        }
        const url = this.itemForm.id 
          ? `/knowledge/data/${this.itemForm.id}`
          : '/knowledge/data'
        const method = this.itemForm.id ? 'put' : 'post'
        const payload = {
          ...this.itemForm,
          dir_id: this.itemForm.dir_id || null,
          markdown_content: this.itemForm.markdown_content,
          has_markdown: this.itemForm.has_markdown,
        };
        this.$api[method](url, payload).then(()=>{
          this.$Message.success('保存成功')
          this.showItemEditor = false
          this.fetchItems()
        }).catch(err=>{
          this.$Message.error('保存失败: ' + err)
        })
      },
      handleItemCancel(){
        this.showItemEditor = false
        this.itemForm = {
          type:'text',
          content:'',
          dir_id:'',
          name:'',
          markdown_content:'',
          has_markdown: false,
        };
        this.editorTab = 'basic';
      },
      handleItemTypeChange(){
        this.itemForm.content = ''
      },
      handleFileUpload(file){
        // 自动获取文件名称
        const fileName = file.name || ''
        if(!this.itemForm.name && fileName){
          // 去掉扩展名作为默认名称
          const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
          this.itemForm.name = nameWithoutExt
        }
        
        this.$cos.upload([file], {
          onSuccess: (files) => {
            if(files && files.length > 0){
              this.itemForm.content = files[0].url
              // 如果还没有设置名称，使用文件名
              if(!this.itemForm.name && fileName){
                const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName
                this.itemForm.name = nameWithoutExt
              }
              this.$Message.success('文件上传成功')
            }
          },
          onFail: (err) => {
            this.$Message.error('文件上传失败: ' + err)
          }
        }, {
          coskey: this.$store.getters['session/session'].coskey
        })
        return false
      },
      handleItemOpen(item){
        this.current = item
        this.showDetail = true
      },
      fillItemForm(item) {
        this.editorTab = 'basic';
        this.itemForm = {
          id: item.id,
          type: item.type,
          content: item.content || '',
          dir_id: item.dir_id != null ? item.dir_id : '',
          name: item.name || '',
          markdown_content: item.markdown_content || '',
          has_markdown: !!(item.has_markdown || item.markdown_content),
          audit_status: item.audit_status,
          rag_status: item.rag_status,
        };
      },
      handleItemEdit(item){
        this.fillItemForm(item);
        this.showItemEditor = true;
      },
      handleItemMarkdown(item) {
        this.fillItemForm(item);
        this.editorTab = 'markdown';
        this.showItemEditor = true;
      },
      handleParseMarkdown() {
        if (!this.itemForm.content) {
          this.$Message.warning('请先上传文件');
          return;
        }
        this.markdownParsing = true;
        setTimeout(() => {
          this.itemForm.markdown_content = this.itemForm.markdown_content || `# ${this.itemForm.name || '文档摘要'}\n\n> 由系统自动解析生成，便于检索与预览。\n\n[查看原文](${this.itemForm.content})`;
          this.itemForm.has_markdown = true;
          this.markdownParsing = false;
          this.$Message.success('Markdown 解析完成');
        }, 800);
      },
      handleSearch(){
        // 搜索逻辑已在computed中处理
      },
      handleToolbarInput(value){
        this.toolBarValue = value
        // 视图切换时更新 viewMode
        if(value && value.toolBarValue && value.toolBarValue.view_mode){
          // viewMode 会通过 computed 自动更新
        }
      },
      getItemIcon(item){
        // 如果是文件类型，根据文件扩展名返回不同图标
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || ''
          const ext = fileName.split('.').pop().toLowerCase()
          return this.getFileIconByExt(ext)
        }
        
        // 其他类型使用固定图标
        const iconMap = {
          text: 'md-document',
          md: 'codelibrary-fill',
          html: 'css',
          ref: 'lianjie',
        }
        return iconMap[item.type] || 'wenjian'
      },
      getFileIconByExt(ext){
        const extIconMap = {
          'txt': 'md-document-text',
          'doc': 'md-document',
          'docx': 'md-document',
          'pdf': 'md-document',
          'xls': 'md-document',
          'xlsx': 'md-document',
          'ppt': 'md-document',
          'pptx': 'md-document',
          'js': 'codelibrary-fill',
          'ts': 'codelibrary-fill',
          'jsx': 'codelibrary-fill',
          'tsx': 'codelibrary-fill',
          'vue': 'codelibrary-fill',
          'py': 'codelibrary-fill',
          'java': 'codelibrary-fill',
          'cpp': 'codelibrary-fill',
          'c': 'codelibrary-fill',
          'go': 'codelibrary-fill',
          'php': 'codelibrary-fill',
          'rb': 'codelibrary-fill',
          'md': 'codelibrary-fill',
          'html': 'css',
          'htm': 'css',
          'xml': 'css',
          'json': 'codelibrary-fill',
          'yaml': 'codelibrary-fill',
          'yml': 'codelibrary-fill',
          'jpg': 'images',
          'jpeg': 'images',
          'png': 'images',
          'gif': 'images',
          'svg': 'images',
          'webp': 'images',
          'bmp': 'images',
          'zip': 'wenjian',
          'rar': 'wenjian',
          '7z': 'wenjian',
          'tar': 'wenjian',
          'gz': 'wenjian',
          'mp4': 'shipin',
          'avi': 'shipin',
          'mov': 'shipin',
          'mp3': 'shipin',
          'wav': 'shipin',
        }
        return extIconMap[ext] || 'wenjian'
      },
      getItemName(item){
        if(item.type === 'file' && item.content){
          const url = item.content
          const fileName = url.split('/').pop() || '未命名文件'
          return fileName
        }
        if(item.type === 'text' || item.type === 'md' || item.type === 'html'){
          const content = item.content || ''
          const firstLine = content.split('\n')[0] || '未命名文档'
          return firstLine.substring(0, 30) + (firstLine.length > 30 ? '...' : '')
        }
        return '未命名'
      },
    }
}
</script>

<style lang="less" scoped>
.knowledge-page {
  height: 100%;
  min-height: 0;
  background: var(--bg2);
}

.markdown-parse-panel {
  padding: 4px 0;
}

/deep/ .knowledge-item-editor-modal {
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-header {
    padding: 0;
    border-bottom: none;
  }
}

.item-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg3) 0%, var(--bg2) 100%);
}

.item-editor-header-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.item-editor-mode {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.item-editor-subtitle {
  font-size: 12px;
  color: var(--subtext2);
}

.item-editor-nav {
  display: inline-flex;
  padding: 3px;
  border-radius: 8px;
  background: var(--bg3);
  border: 1px solid var(--border);
  flex-shrink: 0;
}

.item-editor-nav-btn {
  border: none;
  background: transparent;
  color: var(--subtext2);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;

  &.active {
    background: #fff;
    color: var(--primary);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
}

.item-editor-body {
  padding: 20px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.item-editor-body-markdown {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item-editor-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.item-editor-sidebar {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.sidebar-section {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.sidebar-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--subtext2);
  margin-bottom: 10px;
}

.item-editor-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.editor-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.editor-field-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.editor-title-input /deep/ .ivu-input {
  font-size: 16px;
  font-weight: 500;
}

.editor-textarea /deep/ .ivu-input {
  min-height: 320px;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  line-height: 1.6;
}

.editor-content-panel {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.editor-upload-card {
  padding: 16px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.editor-file-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--border);
  word-break: break-all;
}

.editor-file-empty {
  margin-top: 12px;
  color: var(--subtext3);
  font-size: 13px;
}

.markdown-parse-tip {
  margin-bottom: 0;
}

.markdown-parse-meta,
.editor-source-link {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.markdown-parse-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--subtext2);
}

.item-editor-footer {
  margin-top: 0;
}

.knowledge-modal-content {
  padding: 20px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.knowledge-modal-footer {
  padding: 15px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  background: var(--bg3);
}

.markdown-editor-wrapper {
  position: relative;
  z-index: 1;
  
  /deep/ .v-note-wrapper {
    min-height: 420px;
    z-index: 1;
    border: none;
    box-shadow: none;
  }
  
  /deep/ .v-note-toolbar {
    z-index: 1000 !important;
    position: relative;
  }
  
  /deep/ .v-note-edit {
    min-height: 360px;
  }
}

.html-editor-wrapper {
  position: relative;
  min-height: 420px;
  
  /deep/ .tox-tinymce {
    min-height: 420px;
    border: none;
  }
  
  /deep/ .tox-edit-area {
    min-height: 380px;
  }
}

.type-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.type-selector-vertical {
  flex-direction: column;
  gap: 8px;
}

.type-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;
  border: 2px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 100px;
  background: var(--bg3);
  
  &:hover {
    border-color: var(--primary);
    background: var(--primary-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  &.active {
    border-color: var(--primary);
    background: var(--primary);
    color: #fff;
    box-shadow: 0 4px 12px rgba(51, 153, 255, 0.3);
  }
  
  span {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
  }
}

.type-selector-vertical .type-option {
  flex-direction: row;
  justify-content: flex-start;
  min-width: 0;
  width: 100%;
  padding: 10px 12px;

  span {
    margin-top: 0;
    margin-left: 10px;
    font-size: 13px;
  }

  &:hover {
    transform: none;
  }
}

.knowledge-left-panel {
  background: #fff;
  border-right: 1px solid var(--border);
}

.directory-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border);
  min-height: 40px;
  .directory-panel-title {
    font-weight: 600;
    font-size: 14px;
    color: var(--text);
  }
  .directory-panel-toolbar {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }
  .directory-config-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 1px solid var(--border);
    border-radius: 6px;
    background: var(--bg3);
    color: var(--subtext2);
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;

    &:hover {
      color: var(--primary);
      border-color: var(--primary);
      background: var(--primary-light);
    }
  }
}

/deep/ .knowledge-dir-config-modal {
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-header {
    padding: 0;
    border-bottom: none;
  }
}

.dir-config-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg3) 0%, var(--bg2) 100%);
}

.dir-config-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-light);
  color: var(--primary);
  flex-shrink: 0;
}

.dir-config-header-main {
  min-width: 0;
}

.dir-config-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: var(--subtext2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dir-config-body {
  padding: 18px 20px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

.dir-config-section + .dir-config-section {
  margin-top: 18px;
}

.dir-config-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.dir-config-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-section-desc {
  margin-top: 4px;
  font-size: 12px;
  color: var(--subtext3);
}

.dir-config-card {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.dir-config-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.dir-config-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-switch-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dir-config-switch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--border);
}

.dir-config-switch-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dir-config-switch-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.dir-config-switch-desc {
  font-size: 12px;
  color: var(--subtext3);
}

.dir-config-perm-add {
  margin-bottom: 12px;
  padding: 12px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  background: var(--bg3);
}

.dir-config-perm-add-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dir-config-perm-add-row + .dir-config-perm-add-row {
  margin-top: 10px;
}

.dir-config-perm-flags {
  justify-content: space-between;
}

.dir-config-perm-add-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.dir-config-perm-all-tip {
  flex: 1;
  min-width: 160px;
  padding: 0 10px;
  line-height: 32px;
  color: var(--subtext2);
  font-size: 13px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 4px;
}

.dir-config-perm-table-wrap {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.dir-config-perm-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid var(--border);
    text-align: left;
    font-size: 13px;
  }

  th {
    background: var(--bg3);
    color: var(--subtext2);
    font-weight: 600;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .perm-flag-col {
    width: 72px;
    text-align: center;
  }

  .perm-effect-col {
    width: 100px;
    text-align: center;
  }

  .perm-action-col {
    width: 72px;
    text-align: center;
  }
}

.perm-remove-btn {
  color: var(--error) !important;
}

.dir-config-perm-empty {
  padding: 28px 16px;
  text-align: center;
  color: var(--subtext3);
  font-size: 13px;
}

.dir-config-footer {
  margin-top: 0;
}

.knowledge-client {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.knowledge-main-row {
  flex: 1;
  display: flex;
  width:100%;
  min-height: 0;
  min-width: 0;
}

.knowledge-status-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--subtext2);
  background: var(--bg3);
  border-top: 1px solid var(--border);
  width: 100%;
  .status-path {
    flex: 1;
    overflow: hidden;
    margin-right: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
  }
  .status-path-item {
    display: inline-flex;
    align-items: center;
  }
  .status-path-sep {
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    color: var(--subtext3);
  }
  .status-path-link {
    cursor: pointer;
    color: var(--subtext2);
  }
  .status-path-link:hover {
    color: var(--primary);
  }
  .status-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }
  .status-count,
  .status-usage {
    color: var(--subtext3);
  }
  .status-charger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding-left: 12px;
    border-left: 1px solid var(--border);
  }
  .status-charger-label {
    color: var(--subtext3);
    font-size: 12px;
    white-space: nowrap;
  }
}

.data-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-bottom: 1px solid var(--border);
  gap: 12px;
  .data-search-input {
    width: 200px;
    flex-shrink: 0;
  }
  .data-panel-toolbar {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
    /deep/ .u-toolbar {
      margin-left: auto;
    }
  }
}

.dir-type-selector {
  display: flex;
  gap: 10px;
  
  .dir-type-option {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    border: 2px solid var(--border);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    background: var(--bg3);
    
    &:hover {
      border-color: var(--primary);
      background: var(--primary-light);
    }
    
    /deep/ .ivu-radio-wrapper {
      display: flex;
      align-items: center;
      margin: 0;
      
      .ivu-radio {
        margin-right: 8px;
      }
    }
    
    /deep/ .ivu-radio-wrapper-checked {
      border-color: var(--primary);
      background: var(--primary);
      color: #fff;
    }
  }
}

</style>